<template>
<div>
  1.0
  <el-input v-model="test"></el-input>
  <el-button type="primary" @click="testFD">确 定</el-button>
</div>
</template>

<script>
export default {
  name: "adc",
  data() {
    return{
      test:'',
    }
  },
  methods: {
    testFD(){
      window.location.href = this.test
    },
  }
}
</script>

<style scoped>

</style>